import tools from 'utils';
import api from 'utils/fetch';

export const GET_LIST = 'GET_LIST';

export function getCompanyList() {
  const data = window.companyList.result;
  return (dispatch) => {
    dispatch(getCompanyListSuccess(data));
  };
}

function deleteEnterprisePrefix(url) {
  const urlSplit = url.split('/');
  let urlJoin = [];
  for (let i = 0; i < urlSplit.length; i++) {
    if (urlSplit[i] === 'enterprise' || urlSplit[i - 1] === 'enterprise') {
      continue;
    }
    urlJoin.push(urlSplit[i]);
  }
  return urlJoin.join('/');
}

function redirectToCallbackPath() {
  let callback = tools.getUrlParam('callbackPath');
  if (callback === '') {
    window.location.href = '/my';
  } else {
    window.location.href = deleteEnterprisePrefix(decodeURI(callback));
  }
}

export function setUserChooseRegion(targetRegionIdentifier) {
  return () => api.fetch({
    api: 'setUserChooseRegion',
    data: {
      region: targetRegionIdentifier,
      staffId: window.AK_GLOBAL.keludeUser.staffId
    }
  }).then(() => {
    // redirectToCallbackPath();
    window.location.href = '/my';
  }).fail(() => {
    // redirectToCallbackPath();
    window.location.href = '/my';
  });
}

export function getCompanyListSuccess(data) {
  return {
    type: GET_LIST,
    data
  };
}




/** WEBPACK FOOTER **
 ** ./src/pages/ucBindEmail/actions/index.js
 **/